<template>
  <div class="protocol">
      <div class="c-txt">
            <h2>一般性协议条款</h2>
            <div class="t-items">
              <h3 class="tit">一、总则</h3>
              <p class="des">
                1.1 猎上网络科技（上海）有限公司（以下称：猎上网）同意按照本协议及相关书面协议（如有）的规定及其不时发布的操作规则提供猎上网（www.hunteron.com）网络服务，为获得网络服务，服务使用人（以下称“用户”，包括猎头公司、个人猎头顾问等）应当同意本协议与有关书面协议（如有）的全部条款，其注册、使用账户以及获取网络服务的行为应遵守本协议与有关书面协议的规定。用户应仔细阅读本协议，用户在点击“同意”按钮后即视为用户已完全理解并接受本协议项下的全部条款。
                <br />1.2 用户完成注册后，猎上网工作人员会与您取得联系，协助用户与猎上网签订有关书面协议。用户原则上应在同意本协议并在签订书面协议后才有权使用猎上网提供的网络服务，但如猎上网在未与用户签订书面协议的情况下直接向用户提供了服务，则用户使用猎上网的行为应受本协议条款的约束。
                <br />如用户已与猎上网签订有关的书面协议，则自书面协议签订之日起，当本协议的内容与书面协议相冲突时，以书面协议的内容为准，书面协议未尽事项以本协议的内容为准。
                <br />1.3 用户完成注册后，应自行妥善保管其注册的帐号和密码；用户应当对以其用户帐号进行的所有行为、事件承担法律责任。
                <br />1.4 猎上网有权在必要时修改本协议内容，并以电子邮件或其它适当方式通知用户。如果用户不同意本协议修改后的内容，应通知猎上网，则用户将不再受本协议的约束，其所享有的用户资格与服务也将中止；如果用户继续使用本网站，将被视为同意协议修改后的内容。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">二、用户使用规则</h3>
              <p class="des">
                2.1 用户使用服务的行为须遵守中华人民共和国相关法律法规。
                <br />2.2 用户在申请使用猎上网时，必须向猎上网提供真实、准确的用户资料，如用户资料有任何变动，必须及时更新，若因用户未及时更新资料或其提供的资料不真实、不准确所造成的不利后果由用户自行承担，猎上网有权在此情况下中止为用户提供网络服务。
                <br />2.3 用户不应将其帐号、密码转让或出借予他人使用，如用户违反本条款，由此产生的风险、损失及其他不利后果需由用户自行承担。如用户发现帐号遭他人非法使用，应立即通知猎上网。因黑客行为或用户的自身原因（如未妥善保管账号等）导致帐号、密码遭他人非法使用，猎上网不承担任何责任。
                <br />2.4 用户对其自行发表、上传或传送的内容负全部责任，所有用户不得在猎上网的任何页面发布、转载、传送含有下列内容之一的信息，否则猎上网有权自行处理并不通知用户：
                <br />（1） 违反宪法确定的基本原则的；
                <br />（2） 危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；
                <br />（3） 损害国家荣誉和利益的；
                <br />（4） 煽动民族仇恨、民族歧视，破坏民族团结的；
                <br />（5） 破坏国家宗教政策，宣扬邪教和封建迷信的；
                <br />（6） 散布谣言，扰乱社会秩序，破坏社会稳定的；
                <br />（7） 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
                <br />（8） 侮辱或者诽谤他人，侵害他人合法权益的；
                <br />（9） 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
                <br />（10） 以非法民间组织名义活动的；
                <br />（11） 含有法律、行政法规禁止的其他内容的。
                <br />2.5 用户在使用猎上网提供的网络服务同时应做到：
                <br />（1） 遵守所有与网络服务有关的网络协议、规定和程序；
                <br />（2） 不得为任何非法目的而使用网络服务系统；
                <br />（3） 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；
                <br />（4） 用户不得通过任何技术手段侵入猎上网数据库，进行查阅、直接下载或者转发等功能操作，一经发现猎上网有权停止该用户的账户所有功能，并停止为该用户所在公司名下的所有其他用户提供任何服务。
                <br />（5） 用户有义务保证其在猎上网上发布的信息的真实性，不得夸张描述或编造虚假信息，一经发现，猎上网有权停止相应账户的所有功能，同时停止与该账户所有相关联账户的全部功能。
                <br />（6） 用户不得将猎上网上提供或发布的的任何信息用于使猎上网利益受损的用途（包括但不限于：跳过猎上网同本协议外的任何第三方进行合作、到任何第三方平台发布该等信息等）。一经发现，猎上网有权封停用户的账号并停止提供网络服务且无须征得用户的同意或提前通知用户，用户的上述行为给猎上网造成损失时，猎上网有权要求用户赔偿猎上网由此遭受的全部损失。
                <br />2.6 如用户违反以上规则造成猎上网被第三方索赔的，用户应全额补偿猎上网一切费用(包括但不限于各种赔偿费、诉讼代理费及为此支出的其它合理费用)；
                <br />2.7 如用户违反以上规则，猎上网有权要求用户改正或直接采取一切必要措施(包括但不限于删除用户已发布的内容、暂停或终止用户使用网络服务的权利)以减轻或避免因用户的不当行为而造成的损害或产生的不良影响。
                <br />2.8 用户不可撤销的同意，拨打或接听网站的电话，包括但不限于客服电话、销售电话等，均可能会被录音，用户没有任何异议。
                <br />2.9 用户承诺，其在使用网络服务的过程中，将遵守猎上网不时发布的平台使用规则，用户同时承诺，在其参加由猎上网通过平台发起或举办的线上活动时，应同时遵守猎上网发布的活动规则。用户违反上述承诺时，猎上网有权依据本协议及有关规则的规定，做出相应处理或终止向用户提供服务，且无须征得用户的同意或提前通知用户。
                <br />2.10 猎上网有权拒绝为与本单位经营同类业务、有业务竞争关系或者其他利害关系的单位及个人提供服务。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">三、数据收集与应用</h3>
              <p class="des">
                3.1 当注册成为猎上网的用户时，您将会向猎上网提供您个人/公司信息，包括但不限于联系人的姓名、手机号、电子邮箱、公司名称、公司电话、公司地址等，在猎上网向您提供相关服务的过程中，您也可能向猎上网提供他人的个人信息，包括姓名、联系方式等，猎上网不会从您的电脑、手机等终端主动提取您未提供给猎上网的相关信息。就您提供的信息，猎上网的系统会自动储存。
                <br />3.2 在不透露用户个人隐私的前提下，猎上网有权将用户提供的信息录入数据库，并对整个数据库进行分析以及对数据库中的用户提供的部分或全部的信息用于盈利或其他商业上的用途。
                <br />用户在向猎上网提供第三人的信息时，应保证其对于第三人信息的收集、使用的行为与目的均已获得了被收集者的明示理解与同意。用户保证其有权将被收集人的信息上传至猎上网，同时保证猎上网有权将该等信息基于盈利或其他商业目的而使用，猎上网在使用上述信息时不会受到被收集人的投诉、索赔或其他权利主张，如猎上网因使用用户提供的第三人信息而引起该被收集人的追责，用户应确保猎上网免收任何损害。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">四、版权声明</h3>
              <p class="des">
                4.1 猎上网特有的标识、版面设计、编排方式、等版权均属猎上网享有，未经猎上网许可，不得任意复制或转载。
                <br />4.2 猎上网用户发布的所有内容仅代表发布者的立场和观点，与猎上网无关，由信息发布者承担一切法律责任。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">五、免责声明</h3>
              <p class="des">
                5.1 用户明确同意其使用猎上网提供的网络服务所存在的风险将完全由其自己承担；因其使用猎上网网络服务而产生的一切后果也由其自己承担，猎上网对用户不承担任何责任。
                <br />5.2 猎上网不保证网络服务一定能满足用户的需求，也不保证其所提供的网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。同时，猎上网不保证网站能够长期无错误地运营，也不保证服务器不会受到来自计算机病毒或其他故障的侵扰。
                <br />5.3 猎上网将采取适当的技术措施和其他必要措施维护用户的信息安全，但此等措施并不是万全的，用户理解并同意，如果用户在使用本网站时发生数据丢失的情况，应及时通知猎上网，猎上网将协助用户采取必要的补救措施，但该等补救措施并不能保证用户的数据得以完全修复或恢复。用户理解并同意此类数据丢失的情况与猎上网无关且不会就对应补救措施的过程和结果向猎上网主张任何权利或追究任何责任。
                <br />5.4 猎上网不保证网站信息会有一定的浏览量，也不保证会有一位或数位特定的浏览者来浏览本网站的信息。猎上网对所有信息、文本、图形、链接及其它项目的准确性和完整性也都不作保证，这些信息仅供用户参考使用。
                <br />5.5 用户必须独自承担由于使用猎上网或通过猎上网登录到其他站点而形成的全部风险，并独立承担与他人交流信息所造成的后果。猎上网不担保用户发送或接收的资料的真实性、精确性与可靠性。用户对所接受的资料的信任纯属个人风险。
                <br />5.6 猎上网仅为招聘网络信息发布平台，任何透过猎上网发布的招聘信息及其他产品或者服务均系用户自行发布，猎上网对其合法性概不负责，亦不承担任何法律责任；用户在通过猎上网得到资讯和信息后，其跳过猎上网与信息发布人所进行的任何线下交易均系其双方自主交易，双方若发生纠纷，皆与猎上网无关，猎上网不承担任何法律责任；本公司对于用户由于使用猎上网而造成的任何金钱、商誉、名誉的损失，或任何特殊的、间接的、或结果性的损失都不负任何责任。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">六、违约认定及处理措施</h3>
              <p class="des">
                6.1 发生如下情形之一的，视为您违约：
                <br />（1） 使用本网站提供的服务时违反有关法律法规规定的；
                <br />（2） 违反本协议或有关书面服务协议约定的
                <br />6.2 猎上网可在猎上平台规则中约定违约认定的程序和标准。如：猎上网可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；用户有义务对其的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
                <br />6.3 猎上网发现用户在猎上网平台上发布的信息构成违约时，猎上网可根据相应规则立即对相应信息进行删除、屏蔽处理、中止向用户提供部分或全部服务。如用户的行为构成根本违约的，猎上网有权查封此账户并终止向用户提供服务。
                <br />6.4 用户在猎上网平台上实施的行为，或虽未在猎上网平台上实施但对猎上网平台及其他用户产生影响的行为构成违约的，猎上网可依据相应规则对用户按前款约定进行处理。
                <br />6.5 服务终止后，除法律有明确规定外，猎上网无义务对外发布您的任何信息和需求。
                <br />服务终止后，猎上网仍享有下列权利：
                <br />（1） 继续保存您留存于猎上平台的各类信息；
                <br />（2） 对于您过往的违约行为，猎上网仍可依据本协议及书面协议向您追究违约责任。
                <br />6.6 猎上网可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在猎上网平台上、社区、自媒体或其他媒体上予以公示，届时一切后果由用户自行承担。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">七、通知送达</h3>
              <p
                class="des"
              >本协议要求的所有通知、要求和其他通信，均应以特快专递、传真、电子邮件或猎上网站内通知方式发送。若以特快专递发送，甲方人员签收之日即应认为通知已正式送达；若以传真发送，于传真机显示成功发送的报告时即可认为通知已正式送达；若以电子邮件发送，于电子邮件成功发送的报告时即可认为通知已正式送达；若以站内通知方式发送，于发送后5个工作日即应认为通知已正式到达</p>
            </div>

            <div class="t-items">
              <h3 class="tit">八、不可抗力</h3>
              <p
                class="des"
              >如果发生不可抗力事件，影响一方履行其在本协议条款中项下的义务，则在不可抗力造成的延误期内中止履行，而不视为违约。“不可抗力”指在本特殊条款中签署后发生的、本特殊条款中签署时不能预见的、其发生与后果是无法避免或克服的、妨碍任何一方全部或部分履约的所有事件。上述事件包括地震、台风、水灾、火灾、战争、国际或国内运输中断、流行病、罢工，以及根据中国法律或一般国际商业惯例认作不可抗力的其他事件。</p>
            </div>

            <div class="t-items">
              <h3 class="tit">九、法律管辖</h3>
              <p class="des">
                9.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。
                <br />9.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向猎上网所在地的人民法院提起诉讼。
              </p>
            </div>

            <div class="t-items">
              <h3 class="tit">十、可分性</h3>
              <p class="des">如本协议及书面协议的任一条款被认定为或视为废止、无效或不可执行，不影响本协议其余条款的有效性及可执行性。</p>
            </div>

            <div class="t-items">
              <h3 class="tit">十一、联系信息</h3>
              <p class="des">
                地址及电话
                <br />地址：上海市宝山区逸仙路2816号华滋奔腾大厦B幢16楼
                <br />电话：021-80250888
              </p>
            </div>
          </div>
  </div>
</template>
<style lang="scss" scoped>
  .protocol {
    .c-txt {
        padding: 15px;
        h2 {
            font-size:16px;
            color:#333;
            text-align: center;
        }
        .tit {
            margin:5px;
        }
        line-height: 160%;
    }
  }
</style>
<script>
export default {
  name: "protocol-module",
  data(){
    return {
    }
  },
  watch: {
  },
  components: {},
  methods: {
  },
  created() {
      
  }
};
</script>
